import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/main.scss'
import './styles/main-menu.scss'
import './styles/login.scss'
import './styles/inputs.scss'
import './styles/buttons.scss'
import './styles/header-page.scss'
import './styles/modal.scss'
import './styles/grid.scss'
import './styles/profile.scss'
import 'v-calendar/dist/style.css'
import Notifications from '@kyvg/vue3-notification'


createApp(App).use(store).use(router).use(Notifications).mount('#app')
